import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Dropdown,
  ButtonGroup,
  Form,
  Table,
} from "react-bootstrap";
import { FaCalendarTimes } from "react-icons/fa";
import { BiCalendarEdit } from "react-icons/bi";
import axios from '../../Authservices/axiosInstance';
import { BsPersonPlusFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { FaRegEdit } from "react-icons/fa";
import LeaveLayout from "../../components/LeaveLayout.jsx";

export default function LeaveRecords() {
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [leaveRecords, setLeaveRecords] = useState({ data: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  // Fetch leave records from the API
  const fetchLeaveRecords = async (query = "", page = 1) => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://backend.ems.uk.hiradentallab.com/api/leavesmanual/leave-records",
        {
          params: { search: query, page: page, limit: rowsPerPage },
        }
      );

      setLeaveRecords({
        data: response.data.leaveRecords || [], // Ensure data is set correctly
        total: response.data.leaveRecords.length || 0, // Set total count for pagination
      });
      setLoading(false);
    } catch (error) {
      console.error("There was an error fetching the data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaveRecords(searchQuery, currentPage); // Fetch data on mount or when search/query/page changes
  }, [searchQuery, currentPage]);

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };

  // Handle page change
  const handlePageChange = (pageNumber) => {
    if (
      pageNumber >= 1 &&
      pageNumber <= Math.ceil(leaveRecords.total / rowsPerPage)
    ) {
      setCurrentPage(pageNumber); // Update current page
    }
  };

  // Prevent form submission default reload
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    fetchLeaveRecords(searchQuery, 1); // Reset to the first page when search is submitted
  };

  // Calculate page range
  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(leaveRecords.total / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <LeaveLayout>
      <h1 className="available-leaves-subtitle" style={{ marginTop: "10px" }}>
        <BiCalendarEdit /> Leave Records
      </h1>
      <hr />

      <div className="available-leaves-content">
        <div className="available-leaves-actions">
          <Row>
            <Col xs="auto">
              <Link to="/add-manual-leaves">
                <Button variant="primary" style={{ marginBottom: "10px" }}>
                  <BsPersonPlusFill /> Add Manual Leaves
                </Button>
              </Link>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} className="d-flex align-items-center mb-2">
              <Dropdown as={ButtonGroup}>
                <Button variant="primary">Show Entries</Button>
                <Dropdown.Toggle
                  split
                  variant="primary"
                  id="dropdown-split-basic"
                />
                <Dropdown.Menu>
                  <Dropdown.Item href="#/action-1">10</Dropdown.Item>
                  <Dropdown.Item href="#/action-2">25</Dropdown.Item>
                  <Dropdown.Item href="#/action-3">50</Dropdown.Item>
                  <Dropdown.Item href="#/action-4">100</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={12} md={6} className="d-flex justify-content-end mb-2">
              <div className="search-container">
                <Form className="d-flex" onSubmit={handleSearchSubmit}>
                  <Form.Control
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                    className="available-leaves-search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                </Form>
              </div>
            </Col>
          </Row>
        </div>

        <div className="table-responsive">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <Table striped hover className="table-style">
              <thead className="available-leaves-table-header">
                <tr className="table-header">
                  <th>SR</th>
                  <th>UserName</th>
                  <th>Name</th>
                  <th>Department</th>
                  <th>Leave Count</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {leaveRecords.data && leaveRecords.data.length > 0 ? (
                  leaveRecords.data
                    .slice(
                      (currentPage - 1) * rowsPerPage,
                      currentPage * rowsPerPage
                    )
                    .map((item, index) => {
                      console.log(item); // Debugging step
                      return (
                        <tr key={index}>
                          <td>
                            {(currentPage - 1) * rowsPerPage + index + 1}
                          </td>
                          <td>{item.username}</td>
                          <td>{item.name}</td>
                          <td>{item.department}</td>
                          <td>{item.leaveCount}</td>
                          <td>
                            {/* Check if userId exists and update the Link */}
                            {item.userId ? (
                              <Link to={`/edit-manual-leaves/${item.userId}`}>
                                <Button variant="warning" size="sm">
                                  <FaRegEdit />
                                </Button>
                              </Link>
                            ) : (
                              <p>No User ID</p>
                            )}
                          </td>
                        </tr>
                      );
                    })
                ) : (
                  <tr>
                    <td colSpan="5">No records found</td>
                  </tr>
                )}
              </tbody>

              <tfoot className="available-leaves-table-footer">
                <tr className="table-footer">
                  <td>Total:</td>
                  <td>{leaveRecords.data.length}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </Table>
          )}
        </div>

        {/* Pagination */}
        <div className="pagination-row">
          <div className="entries-info">
            Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
            {Math.min(currentPage * rowsPerPage, leaveRecords.total)} of{" "}
            {leaveRecords.total} entries
          </div>
          <nav>
            <ul className="pagination no-gap">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <a
                  href="/#"
                  className="page-link"
                  onClick={(e) => {
                    e.preventDefault();
                    handlePageChange(currentPage - 1);
                  }}
                >
                  Previous
                </a>
              </li>
              {pageRange().map((pageNumber) => (
                <li
                  key={pageNumber}
                  className={`page-item ${
                    currentPage === pageNumber ? "active" : ""
                  }`}
                >
                  <a
                    href="/#"
                    className="page-link"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePageChange(pageNumber);
                    }}
                  >
                    {pageNumber}
                  </a>
                </li>
              ))}
              <li
                className={`page-item ${
                  currentPage === Math.ceil(leaveRecords.total / rowsPerPage)
                    ? "disabled"
                    : ""
                }`}
              >
                <a
                  href="/#"
                  className="page-link"
                  onClick={(e) => {
                    e.preventDefault();
                    handlePageChange(currentPage + 1);
                  }}
                >
                  Next
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </LeaveLayout>
  );
}


